// Resolves a thrown error to the copy the user should see on 질병코드 관리.
//
// SHCT-702 — this used to end in `defaultValue: err.message`, which published the server's own text
// whenever this app had no copy for the code. A server fault answers with `INTERNAL_ERROR`, which no
// per-feature guard listed, so a raw exception string could reach the operator. The shared resolver
// inverts the rule: show a message only when this app has copy for it, else the operation fallback.

import type { TFunction } from 'i18next';

import { resolveApiErrorMessage } from '@/shared/utils/api-error-message';

import { DiseaseCodeApiError } from '../types/disease-code.types';

const KEY_PREFIX = 'diseaseCodeManagement.errors.';

export function getDiseaseCodeErrorMessage(
  err: unknown,
  t: TFunction,
  fallbackKey: string,
): string {
  if (!(err instanceof DiseaseCodeApiError)) return t(fallbackKey);

  // RANGE_OVERLAP names the range it collided with, so its copy takes interpolation values the
  // other codes have no use for.
  const values =
    err.code === 'RANGE_OVERLAP' && err.meta
      ? {
          conflictGroupName: String(err.meta.conflictGroupName ?? ''),
          conflictRangeStart: String(err.meta.conflictRangeStart ?? ''),
          conflictRangeEnd: String(err.meta.conflictRangeEnd ?? ''),
        }
      : undefined;

  return resolveApiErrorMessage(t, err.code, fallbackKey, err.message, {
    keyPrefix: KEY_PREFIX,
    values,
  });
}
